export const AUTO_ARCHIVE_DEFAULTS = {
  enabled: false,
  days: 30
};

const STORAGE_KEY = 'autoArchiveSettings';
const ALLOWED_DAYS = [7, 14, 30, 60, 90];

export function normalizeAutoArchiveSettings(settings = {}) {
  const days = Number(settings.days ?? settings.autoArchiveDays ?? AUTO_ARCHIVE_DEFAULTS.days);

  return {
    enabled: Boolean(settings.enabled ?? settings.autoArchiveEnabled ?? AUTO_ARCHIVE_DEFAULTS.enabled),
    days: ALLOWED_DAYS.includes(days) ? days : AUTO_ARCHIVE_DEFAULTS.days
  };
}

export function getAutoArchiveSettings() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored
      ? normalizeAutoArchiveSettings(JSON.parse(stored))
      : AUTO_ARCHIVE_DEFAULTS;
  } catch (error) {
    console.error('[autoArchiveSettings] Failed to read settings:', error);
    return AUTO_ARCHIVE_DEFAULTS;
  }
}

export function setAutoArchiveSettings(settings) {
  const normalized = normalizeAutoArchiveSettings(settings);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(normalized));
  window.dispatchEvent(new CustomEvent('autoArchiveSettingsChanged', { detail: normalized }));
  return normalized;
}

export function getAutoArchiveDayOptions() {
  return ALLOWED_DAYS;
}
